

const formatGrowthbookEventAnalytics = (eventCategory: string, eventAction: string) => ({
    eventCategory,
    eventAction
});
export default formatGrowthbookEventAnalytics;
